<template>
  <el-dialog v-loading="loading.dialog" class="toDevelop_model_dialog" top="5vh" center
    :title="'【' + formInfo.taskInfo.pid + '.' + formInfo.taskInfo.id + '】' + '待开发'" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          {{ config.TEXTDOMAINS[form.domain] }}
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          {{ config.TEXTMODULES[form.module] }}
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="产品" :label-width="formLabelWidth">
          {{ config.TEXTUSERS[form.user_pm] }}
        </el-form-item>
        <el-form-item label="开发" label-width="65px">
          {{ config.TEXTUSERS[form.user_rd] }}
        </el-form-item>
        <el-form-item label="测试" label-width="65px">
          {{ config.TEXTUSERS[form.user_qa] }}
        </el-form-item>
      </div>
      <el-form-item v-if="!nonStandard" label="代码分支" prop="branch" :label-width="formLabelWidth">
        <el-select style="width:100%" size="mini" v-model="form.branch" filterable placeholder="请选择代码分支">
          <el-option v-for="(key, value) in BRANCHS" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="技术评审人" prop="tech_reviewer" :label-width="formLabelWidth">
        <el-select style="width:100%" size="mini" v-model="form.tech_reviewer" multiple filterable placeholder="请选择技术评审人">
          <el-option v-for="(key, value) in config.TEXTUSERSEN" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.submit" @click="submit">开 始 开 发</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { postODUDADcreateApi, getDevOpsSpaceListStageParmApi, postDevopsSpaceStageActionApi } from "@/server/tops/devOps";
import { formatStrToArr } from "@/views/tops/devOps/components/util.js"
export default {
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        user_pm: '', user_qa: '', module: '', id: '', pid: '', user_rd: '', domain: ''
      },
      rules: {
        branch: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        tech_reviewer: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '130px',
      BRANCHS: {},
      loading: {
        submit: false,
        dialog: true
      },
    };
  },
  computed: {
    config() {
      return this.$store.state.devOps.ALLSELECT
    },
    nonStandard() { // 非标系统标识
      return this.form.module.startsWith('非标-')
    }
  },
  async created() {
    const { user_pm, user_qa, module = '', id = '', pid = '', user_rd = '', domain = '' } = this.formInfo?.taskInfo || {};
    this.form = { ...this.form, module, id, pid, user_pm, user_qa, user_rd, domain }
    await this.queryDevOpsSpaceListStageParmInfo()
    await this.queryDevOpsSpaceStageSelectmapApi()
  },
  methods: {
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi() {
      const { module = "", domain = '' } = this.form || {};
      try {
        const ret = await postODUDADcreateApi({
          module_name: module || "BACKEND",
          domain
        });
        let branchs = {}
        ret.branchs.map((item) => { branchs[item] = item; });
        this['BRANCHS'] = branchs;
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 获取待开发任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { id, pid } = this.form;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: '19',
          task_id: id,
          pid
        });
        if (ret.status === "success") {
          const { branch, tech_reviewer } = ret.data || {};
          this.form = {
            ...this.form, branch,
            tech_reviewer: formatStrToArr(tech_reviewer)
          }
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.dialog = false;
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 开始开发
    submit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          try {
            const { id, branch, tech_reviewer = [], user_pm, user_qa, user_rd, module, pid = '' } = this.form;
            let param = {
              action: 'run',
              stage_id: '19',
              task_id: id,
              branch,
              stage_name: 'developer_devWaitDevelop',
              tech_reviewer: String(tech_reviewer),
              user_pm, user_qa, user_rd, module, pid
            };
            this.loading.submit = true;
            const ret = await postDevopsSpaceStageActionApi(param);
            let codeDev = ret.data?.output?.codedev || []
            if (codeDev[0].code == 0) {
              this.handleClose();
              //this.handleClose('developing');
            } else {
              this.$notify({
                message: codeDev[0]?.msg || "开始开发失败",
                type: "error",
              });
            }
          } catch (error) {
            this.$notify({
              message: 'error' || "代码报错",
              type: "error",
            });
          }
          finally {
            this.loading.submit = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    }
  }
};
</script>
<style lang="scss">
.toDevelop_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>